<template>
  <router-view />
</template>
<script>

export default {
  name: 'LayoutRouterView',
};
</script>
